import GetOfferManagementSharedState from '../shared/offer-management/state';

export default GetOfferManagementSharedState;
